import tokenStorage from '../helpers/tokenStorage';

export default (acc) => {
  const token = tokenStorage.get();

  if (token !== null) {
    acc.headers.Authorization = `Bearer ${token.access_token}`;
  }

  return acc;
};
